import { twMerge } from "tailwind-merge";

type DividerProps = {
  /** Additional Tailwind CSS classes to apply to the divider. */
  className?: string;
  /**
   * Controls whether the divider is rendered.
   * @default true
   */
  enableDivider?: boolean;
};

/**
 * Renders a horizontal divider.
 *
 * The divider can be conditionally hidden using the `enableDivider` prop
 * and customized with additional CSS classes through the `className` prop.
 *
 * @param props - Props used to configure the divider.
 * @returns The divider element when enabled, otherwise `null`.
 */
export default function Divider({
  className,
  enableDivider = true,
}: DividerProps) {
  if (!enableDivider) {
    return null;
  }
  return (
    <div
      className={twMerge("min-w-full border-b-2 border-pink-300", className)}
    />
  );
}
